import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useAuth } from '../context/AuthContext';
import '../styles/neumorphism.css';

const { FiHome, FiUsers, FiCalendar, FiEye, FiSettings, FiX, FiShield, FiUserCheck, FiActivity } = FiIcons;

function Sidebar({ isOpen, onClose }) {
  const location = useLocation();
  const { user } = useAuth();

  const navigation = [
    { name: 'Dashboard', href: '/', icon: FiHome },
    { name: 'Mitarbeiter', href: '/employees', icon: FiUsers },
    { name: 'Plan erstellen', href: '/generate', icon: FiCalendar },
    { name: 'Plan anzeigen', href: '/schedule', icon: FiEye },
    { name: 'Einstellungen', href: '/settings', icon: FiSettings },
  ];

  // Add admin-only navigation items if user exists and is admin
  if (user && user.role === 'admin') {
    navigation.push(
      { name: 'Benutzerverwaltung', href: '/users', icon: FiUserCheck },
      { name: 'Abteilungsverwaltung', href: '/departments', icon: FiActivity }
    );
  }

  // Safely get user properties with fallbacks
  const userRole = user?.role || 'user';

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 bg-gray-600 bg-opacity-50 z-40 lg:hidden"
          onClick={onClose}
        />
      )}

      <aside
        className={`
          fixed top-0 left-0 z-50 w-64 h-full bg-white transition-transform duration-300 neu-element
          ${isOpen ? 'translate-x-0' : '-translate-x-full'}
          lg:translate-x-0 lg:static lg:z-auto
        `}
      >
        <div className="flex items-center justify-between p-6 border-b border-gray-200 lg:hidden">
          <h2 className="text-lg font-semibold text-gray-900">Navigation</h2>
          <button onClick={onClose} className="p-2 rounded-lg neu-button">
            <SafeIcon icon={FiX} className="w-5 h-5 text-gray-600" />
          </button>
        </div>

        <nav className="mt-28 lg:mt-28 px-4">
          <ul className="space-y-4">
            {navigation.map((item) => {
              const isActive = location.pathname === item.href;
              return (
                <li key={item.name}>
                  <Link
                    to={item.href}
                    onClick={onClose}
                    className={`
                      flex items-center px-4 py-3 text-sm font-medium rounded-lg transition-colors
                      ${isActive
                        ? 'neu-element-inset bg-orange-50 text-orange-700'
                        : 'neu-element text-gray-700'
                      }
                    `}
                  >
                    <SafeIcon
                      icon={item.icon}
                      className={`mr-3 w-5 h-5 ${isActive ? 'text-orange-600' : 'text-gray-400'}`}
                    />
                    {item.name}
                  </Link>
                </li>
              );
            })}
          </ul>

          {/* User Role Badge */}
          {user && (
            <div className="mt-8 p-4 neu-element-inset rounded-lg">
              <div className="flex items-center space-x-2">
                <SafeIcon
                  icon={userRole === 'admin' ? FiShield : FiUsers}
                  className={`w-4 h-4 ${userRole === 'admin' ? 'text-red-600' : 'text-blue-600'}`}
                />
                <span className="text-xs font-medium text-gray-700">
                  {userRole === 'admin' ? 'Administrator' : 'Benutzer'}
                </span>
              </div>
            </div>
          )}
        </nav>
      </aside>
    </>
  );
}

export default Sidebar;